import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListBullets = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 8C7 8.82843 6.32843 9.5 5.5 9.5C4.67157 9.5 4 8.82843 4 8C4 7.17157 4.67157 6.5 5.5 6.5C6.32843 6.5 7 7.17157 7 8ZM28 8C28 7.44772 27.5523 7 27 7H11L10.8834 7.00673C10.386 7.06449 10 7.48716 10 8C10 8.55228 10.4477 9 11 9H27L27.1166 8.99327C27.614 8.93551 28 8.51284 28 8ZM28 16C28 15.4477 27.5523 15 27 15H11.0008L10.8841 15.0067C10.3868 15.0645 10.0008 15.4872 10.0008 16C10.0008 16.5523 10.4485 17 11.0008 17H27L27.1166 16.9933C27.614 16.9355 28 16.5128 28 16ZM27 23C27.5523 23 28 23.4477 28 24C28 24.5128 27.614 24.9355 27.1166 24.9933L27 25H11.0008C10.4485 25 10.0008 24.5523 10.0008 24C10.0008 23.4872 10.3868 23.0645 10.8841 23.0067L11.0008 23H27ZM5.5 17.5C6.32843 17.5 7 16.8284 7 16C7 15.1716 6.32843 14.5 5.5 14.5C4.67157 14.5 4 15.1716 4 16C4 16.8284 4.67157 17.5 5.5 17.5ZM7 24C7 24.8284 6.32843 25.5 5.5 25.5C4.67157 25.5 4 24.8284 4 24C4 23.1716 4.67157 22.5 5.5 22.5C6.32843 22.5 7 23.1716 7 24Z"
	})
});
export default SvgListBullets;
